export default __webpack_public_path__ + "static/media/connecting_web-md@2x.b9b4346f.jpg";